import { useEffect } from 'react';

const BASE_TITLE = 'ONI';

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} — ${BASE_TITLE}` : `${BASE_TITLE} — Seat Delivery for Stadiums & Arenas`;
    return () => {
      document.title = `${BASE_TITLE} — Seat Delivery for Stadiums & Arenas`;
    };
  }, [title]);
}
